import { setUser } from '../../../shared/actions/user';

import { TThunkAction } from '../../../shared/types/redux/thunk';
import { TUser } from '../../types/user/user';
import { getUser } from '../../services/getUser';

export function getUserAction(): TThunkAction<Promise<TUser>> {
  return async (dispatch, _getState, context) => {
    const { httpApi, logger } = context;
    const user = await getUser(httpApi, logger);

    dispatch(setUser(user.user));

    return user.user;
  };
}
